import styles from "./style.module.scss";
import TopBuyerItem from "../topBuyerItem";
import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { ICategoryPageSharedProps } from "@genericTypes/sharedTypes";
import { useRouter } from "next/router";

export default function TopBuyer() {
    const { query } = useRouter();
    const id = query.id;
    const { data } = useQuery<ICategoryPageSharedProps>([
        "categoryPageSharedProps",
    ]);
    const { topBuyers: offers } = data ?? {};
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        const scrollEl = document.getElementById("scrollEl");
        const threshold = 150;

        if (scrollEl) {
            scrollEl.onscroll = () => {
                if (
                    scrollEl?.scrollLeft > threshold ||
                    scrollEl?.scrollLeft < -threshold
                ) {
                    setCurrentPage(2);
                } else {
                    setCurrentPage(1);
                }
            };
        }
    }, []);
    return (
        <>
            <div
                className={`flex ${
                    offers?.length === 1 ? "justify-center" : ""
                } overflow-auto gap-3    p-3 ${styles["scrollBarStyle"]}`}
                id="scrollEl"
            >
                {offers?.slice(0, 3).map((buyer, index) => (
                    <div className={`${styles["hoverStyle"]} `} key={index}>
                        <TopBuyerItem
                            vendor={buyer}
                            categoryId={parseInt((id as string) ?? "0") ?? -1}
                            featured={index === 0 ? true : false}
                        />
                    </div>
                ))}
            </div>
            {(offers?.length ?? 0) > 1 && (
                <div className=" w-fit mx-auto flex gap-[5px] mt-[20px] sm:hidden">
                    <span
                        className={`border border-black rounded-[50%] w-[10px] h-[10px] block ${
                            currentPage === 1 ? "border-none bg-[#1693F0]" : ""
                        }`}
                    ></span>
                    <span
                        className={`border border-black rounded-[50%] w-[10px] h-[10px] block ${
                            currentPage === 2 ? "border-none bg-[#1693F0]" : ""
                        }`}
                    ></span>
                </div>
            )}
        </>
    );
}
